import React from 'react'
import { Sparkles } from 'lucide-react'

export default function SiteHeader() {
    return (
        <header className="flex flex-wrap items-center gap-3 md:gap-6 mb-2">
            <img
                src="https://cdn.brixel.ai/logo/brixel_logo_full.png"
                alt="Brixel SiteBuilder"
                className="h-10 w-auto max-w-[160px] self-start md:self-center select-none"
                draggable={false}
            />
            <h1 className="text-2xl md:text-3xl text-brixel font-extrabold tracking-tight text-gray-900 flex items-center gap-2">
                <Sparkles className="w-6 h-6 text-brixel" />
                <span className="font-bold text-brixel">SiteBuilder</span>
            </h1>
        </header>
    )
}
